// Generated by ReScript, PLEASE EDIT WITH CARE


var $$Document = {};

var redirect = (function(url) {
    return window.location.href=url;
  });

var replaceUrl = (function(url) {
    return window.location.replace(url);
  });

var addClass = (function(elem, class_name) {
    return elem.classList.add(class_name)
  });

var removeClass = (function(elem, class_name) {
    return elem.classList.remove(class_name)
  });

var setParam = (function(url, key, value) {
    let u = new URL(url);
    u.searchParams.set(key, value)
    return u.toString();
  });

var scrollHeight = (function(ele) {
    return ele?.scrollHeight
  });

var offsetTop = (function(ele) {
    return ele?.offsetTop
  });

var switchDisplay = (function (targetClass, position, isVisible) {
        const scopeClassArray = document.querySelectorAll(targetClass);
        scopeClassArray.forEach((targetClass, index)=> {
            if(index == position)
            isVisible ? targetClass.style.display = "block" : targetClass.style.display = "none";
        })
      });

var setChromeAutocompleteOff = (function (parentElQuery, childElQuery) {
  const scopeClassObjects = document.querySelectorAll(parentElQuery);
  if (scopeClassObjects.length > 0) {
    scopeClassObjects.forEach(scopeClass => {
      let inputEl = scopeClass.querySelector(childElQuery);

      if (inputEl && window.chrome) {
        inputEl.setAttribute(
          'onfocus',
          "this.setAttribute('autocomplete', 'chrome-off' );"
        );
      } else if (inputEl) {
        inputEl.setAttribute('name', 'search');
      }
    });
  }
});

var setAddressAutoFillOff = (function (element) {
  let el = document.getElementById(element);
  if (el && window.chrome) {
    el.setAttribute(
      'onfocus',
      "this.setAttribute('autocomplete', 'chrome-off' );"
    );
  } else if (el) {
    el.setAttribute('name', 'search');
  }
});

var $$Window = {};

function isBrowser(param) {
  return ((typeof window === 'undefined')? false : true);
}

var Entry = {};

var $$IntersectionObserver = {
  Entry: Entry
};

export {
  $$Document ,
  redirect ,
  replaceUrl ,
  addClass ,
  removeClass ,
  setParam ,
  scrollHeight ,
  offsetTop ,
  switchDisplay ,
  setChromeAutocompleteOff ,
  setAddressAutoFillOff ,
  $$Window ,
  isBrowser ,
  $$IntersectionObserver ,
}
/* scrollHeight Not a pure module */
